import { useState, useCallback } from 'react';
import { AnalyticsManager, firestore } from '../analytics/AnalyticsManager';
import { ErrorDetails } from '../analytics/AnalyticsEvent';
import { addDoc, collection, serverTimestamp } from 'firebase/firestore';

export function useError() {
    const [error, setError] = useState<Error | null>(null);

    const handleError = useCallback(async (error: Error) => {
        const analytics = AnalyticsManager.getInstance();

        const errorDetails: ErrorDetails = {
            message: error.message,
            stack: error.stack,
            metadata: {
                timestamp: Date.now(),
                url: window.location.href,
                userAgent: navigator.userAgent
            }
        };

        try {
            await analytics.track('error_caught', errorDetails);

            await addDoc(collection(firestore, 'errors'), {
                ...errorDetails,
                timestamp: serverTimestamp()
            });
        } catch (trackingError) {
            console.error('Failed to track error:', trackingError);
        }

        setError(error);
    }, []);

    return { error, handleError };
}